import React, {Profiler} from "react";
import { Box, Typography } from "@mui/material";
import ReactMarkdown from "react-markdown";
import gfm from "remark-gfm";
import "../styles/Instruction.css";
import NavStruct from "../components/NavStruct";

export default function Instruction(props) {

    let text = "Инструкция в разработке";
    const profile = (id, phase, actualTime, baseTime, startTime, commitTime) => {
        if(phase === 'mount'){
            console.log(`${id} component load in ${actualTime} ms`);
        }
    }
    return (
        <Profiler id="Instruction" onRender={profile}>
            <Box sx={{height: '100vh'}}>
                <Box sx={{margin: '20px 0px 0px 50px'}}>
                        <NavStruct/>
                    </Box>
                <Box sx={{margin: '30px 0px 0px 50px'}}>
                    <Typography variant="h4" color={'text.primary'}>Инструкция по работе сервиса для преподавателей</Typography>
                    <ReactMarkdown plugins={[gfm]} children={text}/>
                    <br/>
                    
                </Box>
            </Box>
        </Profiler>
    );
}
